import { Record } from "immutable";

import createFromJS from "../../../createFromJS";

export const SubwayNodeDisplayRecord = Record({
  nodeId: null,
  itemId: null,
  itemType: null,
  sequenceIndex: null,
  titleMetrics: null,
  titleOffset: null,
  label: null,
  color: null,
  isCompleted: false,
  icon: null,
  iconColor: null,
  typeLabel: null,
  typeLabelDisplay: null,
  junction: false,
  x: null,
  y: null,
  threadId: null,
  selected: false
});

createFromJS.registerCallback("SubwayNodeDisplayRecord", createFromJS.createPrimitiveCallback(SubwayNodeDisplayRecord));
